// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/get-organisation-by-external-id-and-event-identifier-async-request-schema',
  type: 'object',
  required: ['externalId', 'eventIdentifier'],
  properties: {
    externalId: {
      type: 'string',
    },
    eventIdentifier: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
